export default {"src":"/_next/static/media/FrictionlessDeployment.375d3e47.svg","height":454,"width":684};